import { Injectable } from '@angular/core';
import * as olProj from 'ol/proj';

@Injectable({
  providedIn: 'root',
})
export class MapService {

  transformCoordinates(coordinates: any) {
    return olProj.transform(coordinates, 'EPSG:4326', 'EPSG:3857');
  }

  getCurrentLocation() {
    return new Promise<GeolocationCoordinates>((resolve, reject) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position.coords),
          (error) => reject(error)
        );
      } else {
        reject('Geolocation not supported');
      }
    });
  }
}
